import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error('useLanguage must be used within a LanguageProvider');
    }
    return context;
};

export const LanguageProvider = ({ children }) => {
    const [currentLanguage, setCurrentLanguage] = useState('en');

    // Load saved language from localStorage
    useEffect(() => {
        const savedLanguage = localStorage.getItem('portfolio-language');
        if (savedLanguage && ['en', 'fr', 'de'].includes(savedLanguage)) {
            setCurrentLanguage(savedLanguage);
        }
    }, []);

    // Save language to localStorage when changed
    useEffect(() => {
        localStorage.setItem('portfolio-language', currentLanguage);
    }, [currentLanguage]);

    const changeLanguage = (language) => {
        if (['en', 'fr', 'de'].includes(language)) {
            setCurrentLanguage(language);
        }
    };

    return (
        <LanguageContext.Provider value={{ currentLanguage, changeLanguage }}>
            {children}
        </LanguageContext.Provider>
    );
};